// @team Subscriptions - Programs & Upsells
import flow from 'lodash/flow';

import GbxUpgradeCheckout from '../../features/Upgrades/pages/gbxUpgradeCheckout';
import { withApolloContext } from '../../utils/apollo';

const Page = flow(withApolloContext({ ssr: true }))(GbxUpgradeCheckout);

Page.displayName = 'GbxUpgradeCheckoutPage';

export default Page;
